module.exports = __webpack_public_path__ + "static/media/port_saaid.91fa84c3.webp";